import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoTermoPaternidade } from './types';

export const INITIAL_STATE: impressaoTermoPaternidade = {
	status: 0,
	data: { arquivoPDF: '' },
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoTermoPaternidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_TERMO_PATERNIDADE_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.IMPRESSAO_TERMO_PATERNIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_TERMO_PATERNIDADE_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.IMPRESSAO_TERMO_PATERNIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
